// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__VbhSl","label":"SetPasswdForm_label__iTPzO"};